import { render, staticRenderFns } from "./BlockSideMenu.vue?vue&type=template&id=1fb275c0&"
import script from "./BlockSideMenu.vue?vue&type=script&lang=js&"
export * from "./BlockSideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports